module.exports = __webpack_public_path__ + "img/25.231bc19a.jpg";